/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Area } from 'react-magnolia';
import styles from './styles.module.css';

const AuthorPage = ({ content }) => (
  <Area {...content} className={styles.contentArea} />
);
export default AuthorPage;
